export default __webpack_public_path__ + "static/media/icon_check.1ac599a5.svg";